import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Toggle from 'react-toggle'
import ServicesList from './ServicesList'
import CheckPermission from '../../common/Permissions/CheckPermission'
import { Button } from '@material-ui/core' // Assuming you're using Material-UI
import CruiseExcelUpload from './Meta Excel components/CruiseExcelUpload'
import ChaletExcelUpload from './Meta Excel components/ChaletExcelUpload'
import ChaletCategoryExcelUpload from './Meta Excel components/ChaletCategoryExcelUpload'
import CategoryExcelUpload from './Meta Excel components/CategoryExcelUpload'
import EventCategoryExcelUpload from './Meta Excel components/EventCategoryUpload'
import EventCompaniesExcelUpload from './Meta Excel components/EventCompanies'
import EventExcelUpload from './Meta Excel components/EventUpload'
import OfferAddExcelUpload from './Meta Excel components/OfferAddExcelUpload'
import OfferCategoryExcelUpload from './Meta Excel components/OfferCategoryExcelUpload'
// import StoreExcelUpload from './Meta Excel components/StoreExcelUpload'
// import StoreItemExcelUpload from './Meta Excel components/StoreItemExcelUpload'
import TripExcelUpload from './Meta Excel components/TripExcelUpload'
import PagesMetaDataSettings from './Meta Excel components/PagesMetaDataSettings'

class ContactUsList extends React.Component {
  state = {
    isloading: false,
    Products_data: [],
    isAppVersionSaving: false,
    user_app_version_detail: {
      id: 1,
      android_version: '0',
      ios_version: '0',
      is_force_update: false,
      app_type: 'user',
    },
    owner_app_version_detail: {
      id: 2,
      android_version: '0',
      ios_version: '0',
      is_force_update: false,
      app_type: 'owner',
    },
  }

  componentDidMount() {
    this.getConstant()
  }

  getConstant = async () => {
    this.setState({ isloading: true })
    await axios
      .get(Constant.getAPI() + `/client/get-client-settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Products_data: [res?.data?.data],
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })

    this.setState({ isloading: false })

    // App version setting
    try {
      var ownerApp = await axios.get(Constant.getAPI() + `/admin/app-version?app_type=owner`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })

      if (ownerApp.status === 200 && ownerApp.data.statusCode === 200 && ownerApp.data.data) {
        this.setState({
          owner_app_version_detail: ownerApp.data.data,
        })
      }
    } catch (error) {
      console.log(error)
    }
    try {
      var userApp = await axios.get(Constant.getAPI() + `/admin/app-version?app_type=user`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })

      if (userApp.status === 200 && userApp.data.statusCode === 200 && userApp.data.data) {
        this.setState({
          user_app_version_detail: userApp.data.data,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleChange = ({ target: { name, value } }) => {
    if (name === 'user_ios_version') {
      this.setState({
        user_app_version_detail: {
          ...this.state.user_app_version_detail,
          ios_version: value,
        },
      })
    } else if (name === 'user_android_version') {
      this.setState({
        user_app_version_detail: {
          ...this.state.user_app_version_detail,
          android_version: value,
        },
      })
    } else if (name === 'owner_ios_version') {
      this.setState({
        owner_app_version_detail: {
          ...this.state.owner_app_version_detail,
          ios_version: value,
        },
      })
    } else if (name === 'owner_android_version') {
      this.setState({
        owner_app_version_detail: {
          ...this.state.owner_app_version_detail,
          android_version: value,
        },
      })
    }
  }

  onAppVersionSettingSave = async () => {
    this.setState({
      isAppVersionSaving: true,
    })

    await axios
      .put(Constant.getAPI() + `/admin/app-version`, this.state.user_app_version_detail, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {})
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })

    await axios
      .put(Constant.getAPI() + `/admin/app-version`, this.state.owner_app_version_detail, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {})
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })

    this.setState({
      isAppVersionSaving: false,
    })
  }

  handleGenerateSitemapEn = async () => {
    this.setState({ isGeneratingSitemapEn: true })

    try {
      // Replace with your actual API endpoint
      const baseUrl = new URL(window.location.href).origin
      console.log(baseUrl, 'currentUrl')
      const response = await axios.get(Constant.getAPI() + `/admin/generate-sitemap-en`, {
        params: {
          baseUrl,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      // Handle successful response
      if (response.data.success && response.data.data.sitemapPath) {
        const sitemapPath = response.data.data.sitemapPath.replace(/\\/g, '/') // Convert backslashes to forward slashes
        const fileUrl = Constant.getImage() + sitemapPath
        // const fileUrl = `file:///${sitemapPath}`; // Construct file URL

        // Optional: Show a success notification

        // Open the sitemap file in a new tab
        window.open(fileUrl, '_blank')
      } else {
        // Optional: Handle any specific error from the API
        alert('Failed to generate sitemap')
      }
    } catch (error) {
      // Handle any network or API errors
      console.error('Error generating sitemap:', error)
      alert('An error occurred while generating sitemap')
    } finally {
      this.setState({ isGeneratingSitemapEn: false })
    }
  }

  handleGenerateSitemapAr = async () => {
    this.setState({ isGeneratingSitemapAr: true })

    try {
      const response = await axios.get(Constant.getAPI() + `/admin/generate-sitemap-ar`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      if (response.data.success && response.data.data.sitemapPath) {
        const sitemapPath = response.data.data.sitemapPath.replace(/\\/g, '/') // Convert backslashes to forward slashes
        const fileUrl = Constant.getImage() + sitemapPath
        window.open(fileUrl, '_blank')
      } else {
        alert('Failed to generate Arabic sitemap')
      }
    } catch (error) {
      console.error('Error generating Arabic sitemap:', error)
      alert('An error occurred while generating Arabic sitemap')
    } finally {
      this.setState({ isGeneratingSitemapAr: false })
    }
  }

  render() {
    const columns = [
      {
        name: 'support_email',
        label: 'Support Email',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'support_phone',
        label: 'Support Phone',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'loyalty_init',
        label: 'Initial Loyalty Points',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'loyalty_earn',
        label: 'Loyalty Points Earning in %',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'loyalty_redeem',
        label: 'Loyalty Points Spending',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'createdAt',
        label: 'Created Date',
        options: {
          filter: true,
          sort: true,
          sortDirection: 'desc',
          customBodyRender: (createdAt) => {
            var date = new Date(createdAt)
            var year,
              month,
              day,
              created_date = ''
            year = date.getFullYear()
            if (date.getMonth() > 8) {
              month = date.getMonth() + 1
            } else {
              month = '0' + (date.getMonth() + 1)
            }
            if (date.getDate() > 9) {
              day = date.getDate() + 1
            } else {
              day = '0' + (date.getDate() + 1)
            }
            created_date = day + ' / ' + month + ' / ' + year
            return <span>{created_date}</span>
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <Link
                to={'/client-settings/' + id}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title="Edit"
              >
                <i className="f-20 icofont icofont-ui-edit text-custom"></i>
              </Link>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      filter: false,
      search: false,
      textLabels: {
        body: {
          noMatch: this.state.isloading ? 'Loading data..!' : 'Sorry, No Record Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <CheckPermission permission={'settings'}>
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Client Setting List</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Client Setting List</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-body">
                <div className="row mb-3">
                  <div className="col-sm-12">
                    <MUIDataTable
                      // title={"Client Setting List"}
                      className="table-responsive"
                      data={this.state.Products_data}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>

            <CheckPermission permission={'settings-services'}>
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Main Services</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <Button
                        startIcon={<i className="icofont icofont-plus"></i>}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          window.location.href = '#/service/add/'
                        }}
                      >
                        Add Service
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-body">
                <div className="row mb-3">
                  <div className="col-sm-12">
                    <ServicesList></ServicesList>
                  </div>
                </div>
              </div>
            </CheckPermission>

            <CheckPermission permission={'manage-app-version'}>
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>App Version Settings</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <div className="card-body">
                        <div className="row">
                          <div
                            className="col-6"
                            style={{ borderRight: '2px solid #ddd' }}
                          >
                            <div className="col-12">
                              <div className="d-inline">
                                <h5 className="m-b-25">User App Version</h5>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">iOS Version</label>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Version"
                                    value={this.state.user_app_version_detail.ios_version}
                                    name="user_ios_version"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">Android Version</label>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Version"
                                    value={this.state.user_app_version_detail.android_version}
                                    name="user_android_version"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">Force Update</label>
                                <div className="col-md-7">
                                  <Toggle
                                    checked={!!this.state.user_app_version_detail.is_force_update}
                                    value={this.state.user_app_version_detail.is_force_update}
                                    onChange={() => {
                                      this.setState({
                                        user_app_version_detail: {
                                          ...this.state.user_app_version_detail,
                                          is_force_update: !this.state.user_app_version_detail.is_force_update,
                                        },
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 border-top">
                            <div className="col-12">
                              <div className="d-inline">
                                <h5 className="m-b-25">Owner App Version</h5>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">iOS Version</label>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Version"
                                    value={this.state.owner_app_version_detail.ios_version}
                                    name="owner_ios_version"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">Android Version</label>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Version"
                                    value={this.state.owner_app_version_detail.android_version}
                                    name="owner_android_version"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-md-5 col-form-label">Force Update</label>
                                <div className="col-md-7">
                                  <Toggle
                                    checked={!!this.state.owner_app_version_detail.is_force_update}
                                    value={this.state.owner_app_version_detail.is_force_update}
                                    onChange={() => {
                                      this.setState({
                                        owner_app_version_detail: {
                                          ...this.state.owner_app_version_detail,
                                          is_force_update: !this.state.owner_app_version_detail.is_force_update,
                                        },
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="row">
                              <div className="text-right col-6 offset-6">
                                {this.state.isAppVersionSaving ? (
                                  <button
                                    className="btn btn-grd-disabled mr-2"
                                    disabled
                                  >
                                    Saving...!
                                  </button>
                                ) : (
                                  <button
                                    onClick={this.onAppVersionSettingSave}
                                    className="btn hor-grd btn-grd-inverse offset-1"
                                  >
                                    <i className="ti-save"></i>Save
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CheckPermission>

            <CheckPermission permission={'manage-meta-tags'}>
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Meta tags Excel Upload</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleGenerateSitemapEn}
                        disabled={this.state.isGeneratingSitemapEn}
                        style={{ padding: '4px 8px', fontSize: '12px', marginRight: '10px' }}
                      >
                        {this.state.isGeneratingSitemapEn ? 'Generating EN...' : 'Generate Sitemap EN'}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleGenerateSitemapAr}
                        disabled={this.state.isGeneratingSitemapAr}
                        style={{ padding: '4px 8px', fontSize: '12px' }}
                      >
                        {this.state.isGeneratingSitemapAr ? 'Generating AR...' : 'Generate Sitemap AR'}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <div className="card-block">
                        <CruiseExcelUpload></CruiseExcelUpload>
                        <CategoryExcelUpload></CategoryExcelUpload>
                        <TripExcelUpload></TripExcelUpload>

                        <ChaletExcelUpload></ChaletExcelUpload>
                        <ChaletCategoryExcelUpload></ChaletCategoryExcelUpload>

                        <EventCategoryExcelUpload></EventCategoryExcelUpload>
                        <EventCompaniesExcelUpload></EventCompaniesExcelUpload>
                        <EventExcelUpload></EventExcelUpload>

                        <OfferAddExcelUpload></OfferAddExcelUpload>
                        <OfferCategoryExcelUpload></OfferCategoryExcelUpload>

                        {/* <StoreExcelUpload></StoreExcelUpload> */}
                        {/* <StoreItemExcelUpload></StoreItemExcelUpload> */}
                      </div>
                    </div>
                    <PagesMetaDataSettings></PagesMetaDataSettings>
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactUsList
